import React from 'react';
import PropTypes from 'prop-types';
import { Close } from '@mui/icons-material';
import Box from './Box';
import IconButton from './IconButton';
import { StyledModalHeader } from './ModalHeader.styled';
function ModalHeader(_ref) {
  var children = _ref.children,
    closeIcon = _ref.closeIcon,
    disableGap = _ref.disableGap,
    elevate = _ref.elevate,
    gutter = _ref.gutter,
    onClose = _ref.onClose,
    transparent = _ref.transparent;
  var CloseIcon = closeIcon || Close;
  return /*#__PURE__*/React.createElement(StyledModalHeader, {
    disableGap: disableGap,
    elevate: elevate,
    gutter: gutter,
    transparent: transparent
  }, /*#__PURE__*/React.createElement(Box, {
    overflow: "hidden",
    width: "100%",
    marginRight: "10px"
  }, children), onClose && /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    size: "small",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CloseIcon, null)));
}
ModalHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Contents to display inside dialog
   */
  children: PropTypes.node.isRequired,
  /**
   * Icon to display in close button.
   */
  closeIcon: PropTypes.node,
  /**
   * If `true`, will remove any margin.
   */
  disableGap: PropTypes.bool,
  /**
   * If `true`, adds box shadow
   */
  elevate: PropTypes.bool,
  /**
   * If `false`, the actions do not have additional margin.
   */
  gutter: PropTypes.bool,
  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  /**
   * If `true`, will not add any background color.
   */
  transparent: PropTypes.bool
} : {};
ModalHeader.defaultProps = {
  closeIcon: undefined,
  disableGap: false,
  elevate: true,
  gutter: true,
  onClose: false,
  transparent: false
};
export default ModalHeader;